import React from "react";
import ReviewCard from "../../../../components/common/formkit/ReviewCard";
import { amenitiesList, amenitiesLabels } from "./Step4Features";

// Strips the rich-text markup for the plain-text summary
const toPlainText = (html) => String(html || "").replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

const formatPrice = (price) =>
  price === "" || price == null || Number.isNaN(Number(price)) ? "" : `₹${Number(price).toLocaleString("en-IN")}`;

/** Review step: read-only summary with Edit links back to each section. */
const Step5Preview = ({ form, goTo, hasMediaStep }) => {
  const feature = form.feature || {};
  const structure = form.structure || {};
  const selectedAmenities = amenitiesList.filter((key) => feature[key]).map((key) => amenitiesLabels[key]);
  const images = form.images || [];
  const videos = form.videos || [];
  const attachments = form.attachments || [];

  return (
    <div className="fk-review-list">
      <div className="fk-section__head" style={{ margin: 0 }}>
        <h2 className="fk-section__title">Review your listing</h2>
        <p className="fk-section__hint">Check everything below, then publish. Use Edit to change a section.</p>
      </div>

      <ReviewCard
        title="Basic details"
        onEdit={() => goTo("basic")}
        rows={[
          { label: "Purpose", value: form.propertyPurposeName },
          { label: "Property type", value: form.propertyTypeName },
          { label: "Subtype", value: form.propertySubtypeName },
          { label: "Sub sub type", value: form.propertySubSubTypeName },
          { label: "Area", value: form.are },
          { label: "Land type", value: form.landTypeName },
          {
            label: "Loan availability",
            value: typeof form.loanAvailability === "boolean" ? (form.loanAvailability ? "Yes" : "No") : "",
          },
        ]}
      />

      <ReviewCard
        title="Pricing & location"
        onEdit={() => goTo("details")}
        rows={[
          { label: "Title", value: form.name },
          { label: "Budget", value: formatPrice(form.price) },
          { label: "State", value: form.stateName },
          { label: "City", value: form.cityName },
          { label: "Area", value: form.area },
          { label: "Description", value: toPlainText(form.description), full: true },
        ]}
      />

      <ReviewCard
        title="Features & amenities"
        onEdit={() => goTo("features")}
        rows={[
          { label: "Bedrooms", value: structure.bed_rooms || "" },
          { label: "Bathrooms", value: structure.bath_rooms || "" },
          { label: "Rooms", value: structure.rooms || "" },
          { label: "Pin code", value: form.pin_code },
          { label: "Address", value: form.address, full: true },
          { label: "Tags", value: form.tags, full: true },
          { label: "Amenities", value: selectedAmenities.join(", "), full: true },
        ]}
      />

      {hasMediaStep && (
        <ReviewCard
          title="Media"
          onEdit={() => goTo("media")}
          rows={[
            { label: "Images", value: images.length },
            { label: "Videos", value: videos.length },
            { label: "Documents", value: attachments.length },
          ]}
        >
          {images.length > 0 && (
            <div className="fk-media-grid">
              {images.slice(0, 6).map((img, i) => (
                <div className="fk-media" key={`${img.url}-${i}`}>
                  <img className="fk-media__thumb" src={img.url} alt={img.name || `Image ${i + 1}`} />
                </div>
              ))}
            </div>
          )}
        </ReviewCard>
      )}
    </div>
  );
};

export default Step5Preview;
